import { render, staticRenderFns } from "./SurveyRulePrompts.vue?vue&type=template&id=5d97086a&scoped=true"
import script from "./SurveyRulePrompts.vue?vue&type=script&lang=js"
export * from "./SurveyRulePrompts.vue?vue&type=script&lang=js"
import style0 from "./SurveyRulePrompts.vue?vue&type=style&index=0&id=5d97086a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97086a",
  null
  
)

export default component.exports